import { useState } from "react";

function App() {
  const [input, setInput] = useState("");
  const [highlightedText, setHighlightedText] = useState(null);
  const [detectionList, setDetectionList] = useState(null);

  const checkString = (text) => {
    if (!text) return; // Prevent empty input from triggering output

    let highlighted = [];
    let detections = [];

    text.split("").forEach((char, index) => {
      if (char === "0") {
        highlighted.push(<span key={index} style={{ color: "#00FFFF", fontWeight: "bold" }}>0</span>); // Neon Cyan for Zero
        detections.push(`Position ${index + 1}: '0' is a Zero`);
      } else if (char === "O") {
        highlighted.push(<span key={index} style={{ color: "#FF5733", fontWeight: "bold" }}>O</span>); // Orange for Uppercase O
        detections.push(`Position ${index + 1}: 'O' is an Uppercase O`);
      } else if (char === "o") {
        highlighted.push(<span key={index} style={{ color: "#FFD700", fontWeight: "bold" }}>o</span>); // Gold for Lowercase o
        detections.push(`Position ${index + 1}: 'o' is a Lowercase o`);
      } else {
        highlighted.push(char);
      }
    });

    setHighlightedText(highlighted);
    setDetectionList(detections.length > 0 ? detections : ["No '0' or 'O' found."]);
  };

  return (
    <div style={{
      textAlign: "center",
      padding: "50px",
      fontFamily: "'Orbitron', sans-serif",
      backgroundColor: "#121212",
      color: "#FFFFFF",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <h1 style={{ fontSize: "32px", textShadow: "0px 0px 10px #00FFFF" }}>
        Is it a ZERO?
      </h1>
      <input
        type="text"
        placeholder="Type something..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{
          padding: "12px",
          fontSize: "18px",
          backgroundColor: "#222",
          border: "2px solid #00FFFF",
          borderRadius: "8px",
          color: "#FFF",
          textAlign: "center",
          outline: "none",
          width: "300px",
          marginBottom: "15px"
        }}
      />
      <br />
      <button
        onClick={() => checkString(input)}
        style={{
          padding: "12px 25px",
          fontSize: "18px",
          border: "none",
          borderRadius: "8px",
          backgroundColor: "#00FFFF",
          color: "#121212",
          cursor: "pointer",
          fontWeight: "bold",
          textTransform: "uppercase",
          boxShadow: "0px 0px 10px #00FFFF"
        }}
      >
        Check
      </button>
      
      {/* Only display results if input has been checked */}
      {highlightedText !== null && (
        <div style={{
          marginTop: "20px",
          fontSize: "22px",
          backgroundColor: "#222",
          padding: "15px",
          borderRadius: "10px",
          width: "50%",
          textAlign: "center",
          minHeight: "50px",
          boxShadow: "0px 0px 10px rgba(0, 255, 255, 0.5)"
        }}>
          <p>{highlightedText}</p>
        </div>
      )}

      {detectionList !== null && (
        <div style={{
          marginTop: "20px",
          fontSize: "18px",
          backgroundColor: "#1A1A1A",
          padding: "15px",
          borderRadius: "10px",
          width: "50%",
          textAlign: "left",
          minHeight: "50px",
          boxShadow: "0px 0px 10px rgba(255, 215, 0, 0.5)"
        }}>
          <h3 style={{ textAlign: "center", textShadow: "0px 0px 5px #FFD700" }}>Detection List</h3>
          <ul style={{ listStyleType: "none", padding: "0" }}>
            {detectionList.map((result, idx) => (
              <li key={idx} style={{ marginBottom: "5px", textAlign: "center" }}>{result}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default App;
